<template>
    <div class="container mt-5 text-center">
        <h3>Contratos</h3>
        <div v-if="loading" class="spinner-border mt-2" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="container">
            <div class="table-responsive">
                <div class="container-fluid">
                    
                    <!-- Cabecera solo visible en pantallas medianas o mayores -->
                    <div class="row font-weight-bold border-bottom py-2 d-none d-md-flex bg-light">
                        <div class="col-md-2 text-center">Id</div>
                        <div class="col-md-3 text-center">Dirección</div>
                        <div class="col-md-2 text-center">Días semana</div>
                        <div class="col-md-3 text-center">Horario</div>
                        <div class="col-md-2 text-center">Opciones</div>
                    </div>
                    <div v-if="items.length>0">
                        <div v-for="item in items" :key="item.contro_id">
                            <!-- Tarjeta de datos -->
                            <div class="row py-3 border-bottom">
                                <div class="col-12 col-md-2 text-center">
                                    <strong class="d-md-none">Id:</strong> {{ item.contro_id }}
                                </div>
                                <div class="col-12 col-md-3 text-center">
                                    <strong class="d-md-none">Dirección:</strong> {{ item.direccion1 }}
                                </div>
                                <div class="col-12 col-md-2 text-center">
                                    <strong class="d-md-none">Días semana:</strong> {{ item.diascontro }}
                                </div>
                                <div class="col-12 col-md-3 text-center">
                                    <strong class="d-md-none">Horario:</strong> {{ item.horario }}
                                </div>
                                <div class="col-12 col-md-2 text-center mt-2 mt-md-0">
                                    <button type="button" class="btn btn-primary btn-sm" @click="irAContratas(item)">
                                        FICHAR
                                    </button>
                                </div>
                            </div>
    
                            <!-- Separador solo en móviles -->
                            <hr style="border-top:2px solid black" class="d-md-none my-2 ">
                        </div>

                    </div>
                    <div v-else class="mt-5">
                        <p>{{ mensaje }}</p>
                    </div>
                </div>

            </div>
        </div>
        <div>
            <simple-modal v-model="isShow" title="Detalle">
                <template slot="body">
                    <br>
                    <button @click="isShow = false" class="btn btn-primary mt-3">Cerrar</button>
                </template>

                <template slot="footer">
                    <button>OK</button>
                </template>
            </simple-modal>
        </div>

    </div>
</template>

<script>
import SimpleModal from 'simple-modal-vue'

import api from "../config/api";
export default {
    components: { SimpleModal },
    data() {
        return {
            items: [],
            user: { numero: 0 },
            loading: false,
            isShow: false,
            row: {},
            horario: null,
            dias: null,
            categoria: null,
            contro_id: null,
            mensaje:null
        }
    },
    async mounted() {
        //this.user = JSON.parse(localStorage.getItem('user'))
        localStorage.setItem('user', JSON.stringify({numero:this.$route.params.id}))
        this.user.numero = this.$route.params.id;
        console.log('-->', this.user)
        // this.$isLoading(true)
        await this.getData()
        // this.$isLoading(false)

    },
    methods: {
        irAContratas(item) {
            console.log(item)

            let dataTmp = item
            localStorage.setItem('controdata', JSON.stringify(dataTmp))
            console.log(dataTmp)
            this.horario = dataTmp.horario
            this.dias = dataTmp.diascontro; //dataTmp[0].diassemana[0]
            this.categoria = dataTmp.categoria
            if (this.contro_id == 0) {
                alert('Debes seleccionar contrato!')
                return
            }
            if (this.horario.length == 0 && dataTmp.flexible_total != 1) {
                alert('No puedes fichar, contrato sin horario o no flexible!')
                return
            }
            if (this.dias.length == 0 && dataTmp.flexible_total != 1) {
                alert('no puedes fichar, contrato sin días ó no flexible!')
                return
            }
            this.$router.push('/fichajeV2')
        },
        showModal(item) {
            this.row = item
            this.isShow = true
        },
        async getData() {
            // let resultv = await api.request("get", '/BMGES_obtenerContratos/' + this.user.numero);
            this.$isLoading(true)
            let resultv = await api.request("get", '/obtenerContratos/' + this.user.numero);
            let res = resultv.data
            this.items = res
            if(this.items.length== 0){
                this.mensaje = "No hay contratos para este día"
            }
            this.$isLoading(false)
            //console.log('tareas', resultv)
        }
    }
}

</script>

<style></style>